export const VERIFICATION_STEPS = {
  BASIC_INFO: 0,
  ADDRESS: 1,
  OPERATING_HOURS: 2,
  CONTACTS: 3,
  CAPABILITIES: 4,
  SERVICES_PRICING: 5,
  REVIEW: 6,
} as const;

export const VERIFICATION_STEP_NAMES = [
  'Basic Info',
  'Address',
  'Hours',
  'Contacts',
  'Capabilities',
  'Services & Pricing',
  'Review',
];

export const VERIFICATION_TOTAL_STEPS = 7;

export type StepStatus = 'pending' | 'confirmed' | 'updated' | 'skipped';

export interface VerificationStepState {
  status: StepStatus;
  notes?: string;
}

export interface VerificationQueueItem {
  id: number;
  name: string;
  code?: string;
  city?: string;
  state?: string;
  phone?: string;
  lastVerifiedDate?: string;
  daysOverdue: number;
  neverVerified: boolean;
  reliabilityScore?: number;
}
